function debounce<TFunc extends Function>(this: unknown, func: TFunc, timeout = 300, abortController?: DebounceAbortController) {
	let timer: NodeJS.Timeout | undefined;

	abortController?.onAbort(() => {
		if (timer) {
			clearTimeout(timer);
			timer = undefined;
		}
	});

	return (...args: unknown[]) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			timer = undefined;
			func.apply(this, args);
		}, timeout);
	};
}

class DebounceAbortController {
	private readonly eventTarget: EventTarget;

	constructor() {
		// Old browsers do not support EventTarget as a stand alone class. We
		// fallback to using a document fragment which implements the same
		// interface.
		if (window['EventTarget']) {
			this.eventTarget = new EventTarget();
		} else {
			this.eventTarget = document.createDocumentFragment();
		}
	}

	public abort(): void {
		this.eventTarget.dispatchEvent(new Event('abort'));
	}

	public onAbort(listener: () => void): void {
		this.eventTarget.addEventListener('abort', listener);
	}
}

export {
	debounce,
	DebounceAbortController,
};
